<template>
  <div class="body">
    <van-nav-bar title="售后" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <van-tabs v-model="active" animated color="#e9aea8">
        <van-tab title="全部">
          <Suptabs state="-1"/>
        </van-tab>
        <van-tab title="待处理">
          <Suptabs state="0"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Suptabs from "./SupportTabs.vue";
import { GetSup } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { Tab, Tabs } from "vant";
import Vue from "vue";
Vue.use(Tab).use(Tabs);
export default {
  components: {
    Suptabs
  },
  data() {
    return {
      active: 0,
      state: -1,
      page: 1,
      list: [],
      hasData: false
    };
  },
  created() {},
  activated() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
  }
}
</style>